import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, TextField, Button, Stack } from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import useUserGuideList from '../../hooks/user-guide/useUserGuideList';

const API_URL = 'https://yourapi.com/api/userguidesection';

export default function UserGuideSections({ userGuideId }) {
//   const [sections, setSections] = useState([]);
  const [newSection, setNewSection] = useState({ section_title: '', content: '' });
  const [editId, setEditId] = useState(null);

//   const fetchSections = async () => {
//     const res = await axios.get(`${API_URL}?userGuideId=${userGuideId}`);
//     setSections(res.data);
//   };

   const{guides,
           selectedGuide,
           selectedGuidID,
           setSelectedGuide,
           setSelectedGuideID,
          loadWarehouseByID,
          fetchUserGuideListByID,
          sections,  setSections,}= useUserGuideList(null);

  useEffect(() => {
    fetchUserGuideListByID(userGuideId);
  }, [userGuideId]);

  const handleSave = async () => {
    if (editId)
      await axios.put(`${API_URL}/${editId}`, newSection);
    else
      await axios.post(API_URL, { ...newSection, user_guide_id: userGuideId });

    setNewSection({ section_title: '', content: '' });
    setEditId(null);
     fetchUserGuideListByID(userGuideId);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
     fetchUserGuideListByID(userGuideId);
  };

  return (
    <Box p={2}>
      <Typography variant="subtitle1">Sections</Typography>
      {sections.map((s) => (
        <Box key={s.section_id} border={1} borderRadius={2} p={1} mb={1}>
          <Typography fontWeight="bold">{s.section_title}</Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{s.content}</Typography>
          <IconButton onClick={() => { setEditId(s.section_id); setNewSection(s); }}><Edit /></IconButton>
          <IconButton onClick={() => handleDelete(s.section_id)}><Delete /></IconButton>
        </Box>
      ))}

      <Stack spacing={1} mt={2}>
        <TextField label="Section Title" value={newSection.section_title} onChange={(e) => setNewSection({ ...newSection, section_title: e.target.value })} />
        <TextField multiline rows={3} label="Content" value={newSection.content} onChange={(e) => setNewSection({ ...newSection, content: e.target.value })} />
        <Button variant="contained" startIcon={<Add />} onClick={handleSave}>
          {editId ? 'Update Section' : 'Add Section'}
        </Button>
      </Stack>
    </Box>
  );
}
